import {
    ActionBtn, Label, LoaderDiv, MessageError, MessageError2, LoaderText
} from './styles';
import { IPresenterProps } from './types';
import CustomInput from '../../../components/Input/Container';
import Spinner from '../../../components/Spinner';
import COLORS from '../../../utils/Colors';

const LoginContainer = (props: IPresenterProps) => {

    return (
        <>
            <div style={{ marginBottom: 20 }}>
                <div style={{ marginBottom: 12 }}>
                    <Label htmlFor="resetPassword1">Nueva Contraseña</Label>
                </div>
                <CustomInput
                    inputType="password"
                    value={props.formData.resetPassword1}
                    onChange={(e: any) => props.onChange(e, 'resetPassword1')}
                    bgColor={COLORS.white}
                    disabled={false}
                    showDeleteTextIcon={false}
                    deleteText={() => { }}
                    textColor={COLORS.black}
                    showError={false}
                />
                {
                    props.resetPasswordError &&
                    <>
                        <MessageError>La contraseña debe cumplir estos requisitos:</MessageError>
                        <MessageError2>Mínimo ocho (8) caracteres. Contener al menos una (1) mayúscula (A-Z), minúscula (a-z) o carácter especial (~`!@#$%^&)</MessageError2>
                    </>
                }
            </div>
            <div style={{ marginBottom: 65 }}>
                <div style={{ marginBottom: 12 }}>
                    <Label htmlFor="resetPassword2">Confirmar Nueva Contraseña</Label>
                </div>
                <CustomInput
                    inputType="password"
                    value={props.formData.resetPassword2}
                    onChange={(e: any) => props.onChange(e, 'resetPassword2')}
                    bgColor={COLORS.white}
                    disabled={false}
                    showDeleteTextIcon={false}
                    deleteText={() => { }}
                    textColor={COLORS.black}
                    showError={false}
                />
                {
                    props.passwordsNotMatchErrorMsg &&
                    <MessageError>Las contraseñas ingresadas no coinciden. Inténtalo de nuevo.</MessageError>
                }
            </div>

            {props.loaderVisible ? (
                <LoaderDiv>
                    <Spinner size={40} color="#000000" thickness={3} />
                    <LoaderText>Actualizando contraseña...</LoaderText>
                </LoaderDiv>
            ) : (
                <>
                    <ActionBtn onClick={props.actionBtn}>
                        Restablecer Contraseña
                    </ActionBtn>
                    <div onClick={() => props.changeStep(1)} style={{ marginTop: 28, cursor: 'pointer' }}>
                        <p style={{ textAlign: 'center', fontSize: 18, color: COLORS.white }}>Cancelar</p>
                    </div>
                </>
            )}
        </>
    )
};

export default LoginContainer;
